// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvpxbi{padding-left:var(--ds-space-200,1pc)}\n._ca0q12x7{padding-top:var(--ds-space-075,6px)}\n._ca0qu2gc{padding-top:var(--ds-space-100,8px)}\n._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}\n._u5f3u2gc{padding-right:var(--ds-space-100,8px)}", ""]);
// Exports
module.exports = exports;
